import React from 'react';
import autobind from 'autobind-decorator';
import {Button, Col, Row, Table} from 'react-bootstrap';
import {Glyphicon} from "../../Common/GlyphIcon";
import {HelpIcon} from "../../Common/HelpIcon";
import Autocomplete from 'react-autocomplete';

import {SurveyFormInput} from "../../Common/SurveyForm";

export class AncillaryBenefits extends React.Component {
    constructor(props) {
        super(props);
    }

    @autobind
    getConservationAction() {
        return this.props.ConservationAction;
    }

    @autobind
    getPopulatedAnswers() {
        let ret = [];

        let questions = this.props.GetQuestionsForSection();
        questions.forEach((x) => {
            let answer = this.props.GetQuestionAnswer(x);

            if(answer) {
                ret.push(answer);
            }
        });


        return ret;
    }

    @autobind
    getRemainingQuestions() {
        let ret = [];
        let questions = this.props.GetQuestionsForSection();
        let answers = this.getPopulatedAnswers();
        let filledQuestionIds = answers.map((x) => x.surveyQuestionId);

        return questions.filter((x) => !filledQuestionIds.includes(x.surveyQuestionId));
    }

    @autobind
    addNextAnswer() {
        let conservationAction = this.getConservationAction();
        let questions = this.getRemainingQuestions();
        let question = null;

        if(questions.length) {
            question = questions[0];
        }

        if(question) {
            this.props.OnAnswerChange({
                surveyQuestionId: question.surveyQuestionId,
                conservationActionId: conservationAction.conservationActionId
            });
        }
    }

    @autobind
    deleteAnswer(answer) {
        if(this.props.DeleteAnswer) {
            this.props.DeleteAnswer(answer);
        }
    }

    @autobind
    onSave() {
        if(this.props.OnSave) {
            this.props.OnSave();
        }
    }

    render() {
        let questions = this.props.GetQuestionsForSection();
        let conservationAction = this.getConservationAction();
        let remainingQuestions = this.getRemainingQuestions();

        if(questions.length === 0) {
            return <Col key={this.props.Section.surveySectionId} id={this.props.id}>
                <Row>
                    <Col xs={12}>
                        <h3>{this.props.Section.name}</h3>
                        {
                            this.props.Section.description ?
                                <h4>{this.props.Section.description}</h4>:
                                null
                        }
                    </Col>
                    <Col xs={12}>
                        <p>No Ancillary Benefits defined.</p>
                    </Col>
                </Row>
            </Col>;
        }

        return <Col key={this.props.Section.surveySectionId} id={this.props.id}>
            <Row>
                <Col xs={12}>
                    <h3>{this.props.Section.name}</h3>
                    {
                        this.props.Section.description ?
                            <h4>{this.props.Section.description}</h4>:
                            null
                    }
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <Table className="sb-survey-form-table" striped size="sm" bordered>
                        <tbody>
                            {
                                this.getPopulatedAnswers().map((x) => {
                                    let question = this.props.GetAnswerQuestion(x);
                                    if(!question) {
                                        return null;
                                    }
                                    let questions = this.getRemainingQuestions();
                                    questions.push(question);

                                    return <tr key={question.surveyQuestionId}>
                                        <td>
                                            {
                                                this.props.EditMode ?
                                                    <React.Fragment>
                                                        <Autocomplete
                                                            getItemValue={(item) => item.name}
                                                            items={questions}
                                                            renderItem={(item, isHighlighted) =>
                                                              <div key={item.name} style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                                                                {item.name}
                                                              </div>
                                                            }
                                                            value={question.name}
                                                            onSelect={(value, item) => {
                                                                x.surveyQuestionId = item.surveyQuestionId;
                                                                this.props.OnAnswerChange(x);
                                                            }}
                                                        />
                                                        <div>
                                                            <HelpIcon id={"question-help-text-" + question.surveyQuestionId}>{question.helpText}</HelpIcon>
                                                            <span>{question.description}</span>
                                                        </div>
                                                    </React.Fragment>:
                                                    <React.Fragment>
                                                        <div>{question.name}</div>
                                                    </React.Fragment>
                                            }
                                            {
                                                this.props.EditMode ?
                                                    <Col xs={1} className="remove-table pop-remove">
                                                        <a onClick={() => this.deleteAnswer(x)}>
                                                            <Glyphicon glyph="remove-sign" />
                                                        </a>
                                                    </Col> :
                                                    null
                                            }
                                        </td>
                                        <td>
                                            <SurveyFormInput
                                                EditMode={this.props.EditMode}
                                                ConservationAction={conservationAction}
                                                Question={question}
                                                Answer={x}
                                                OnChange={this.props.OnAnswerChange}
                                            />
                                        </td>
                                    </tr>;
                                })
                            }
                            {
                                this.props.EditMode ?
                                    (
                                        remainingQuestions.length ?
                                            <tr className="sb-mutable-list-add-section" onClick={this.addNextAnswer}>
                                                <td colSpan={2}>
                                                    <a><Glyphicon glyph="plus-sign" />Add Ancillary Benefits</a>
                                                </td>
                                            </tr>:
                                            null
                                    ):
                                    null
                            }
                        </tbody>
                    </Table>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    {
                        this.props.EditMode ?
                            <Button onClick={this.onSave} variant="primary" className="float-right">
                                Save and Continue
                            </Button>:
                            null
                    }
                </Col>
            </Row>
        </Col>;
    }
}


